/* eslint-disable max-lines */
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, concatMap, tap } from 'rxjs';
import { MyQuotesFactory } from './my-quotes.factory';
import { DownloadPDFPayload, EquipmentQuoteHeader, EquipmentQuoteListResponse, MyQuotesGridListLabel, MyQuotesGridListObj, MyQuotesLabelState, MyQuotesPayload, MyQuotesSectionMiddleLabel, MyQuotesState, StatusPayload } from './definitions';
import { ApiService } from '../../services/api/api.service';
import { DateRange, KngCardListState, KngHeaderObjState, KngStatusSelectorState, KngValueListState, KngValueObjState, Option, ScreenView, SortOrder } from 'kinetic-angular';
import { ErrorMessage, FieldName, FileName, Icons } from '../../services/shared/shared-enums';
import { DateConverterService } from '../../services/date-converter/date-converter.service';
import { SharedUtilService } from '../../services/shared/shared-util.service';
import { SharedService } from '../../services/shared/shared.service';
import { ApiResponse } from '../../definitions/api-response.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { LoggerService } from '../../services/logger/logger.service';
import { MyQuotesUtilService } from './my-quotes.util.service';
import { TrackFileDownload } from '../../services/analytics/definitions';
import { expEnvironmentRef } from '../../injection-tokens/environment.injection-token';
import { EnvironmentRef } from 'projects/tmhna-portal/src/environments/interfaces';
@Injectable({
	providedIn: 'root'
})
export class MyQuotesService 
{
	private readonly state$: BehaviorSubject<MyQuotesState> = new BehaviorSubject<MyQuotesState>(MyQuotesFactory.build());
	invoiceStatusCount: KngStatusSelectorState = MyQuotesFactory.buildInvoiceStatusCount();
	myQuotesTableLabels: MyQuotesGridListLabel = MyQuotesFactory.buildMyQuotesTableLabels();
	myQuotesCardListObject: KngCardListState = MyQuotesFactory.buildMyQuotetList();
	myQuotesTableStateObject: BehaviorSubject<KngCardListState> = new BehaviorSubject<KngCardListState>(MyQuotesFactory.buildMyQuotetList());
	totalCount: number = 0;
	searchData: string = '';
	showStatusFilters: boolean = false;
	myQuotesPayload: MyQuotesPayload = this.myQuotesUtilService.getDefaultPayload();
	sortingEvent = this.sharedUtilService.getHeaderObjectState(true, EquipmentQuoteHeader.creationDate, SortOrder.desc);
	currentDate = new Date();
	get isRaymond(): boolean
	{
		return this.environmentRef.isRaymond || false;
	}
	get state(): MyQuotesState 
	{
		return this.state$.value;
	}
	set updateCardState(value: KngCardListState)
	{
		this.myQuotesTableStateObject.next(value);
	}
	constructor(public apiService: ApiService, public dateService: DateConverterService, public sharedUtilService: SharedUtilService, public sharedService: SharedService, private readonly loggerService: LoggerService,
		private readonly toaster: ToastrService, private readonly myQuotesUtilService: MyQuotesUtilService, @Inject(expEnvironmentRef) readonly environmentRef: EnvironmentRef){}

	public updateState(value: MyQuotesState): void 
	{
		this.state$.next(value);
	}
	public getMyQuotesLabelState(): void 
	{
		this.apiService.getMyQuotesAemLabels().subscribe((res: MyQuotesLabelState) => 
		{
			if (res) 
			{
				this.state.sectionTop.heading = res.sectionTop.heading;
				this.getMyQuotesMiddleLabelState(res.sectionMiddle);
			}
		});
	}
	public getMyQuotesMiddleLabelState(resSectionMiddle: MyQuotesSectionMiddleLabel)
	{
		const sectionMiddle = this.state.sectionMiddle;
		sectionMiddle.heading = resSectionMiddle.heading;
		sectionMiddle.search = resSectionMiddle.search;
		sectionMiddle.search.invalidSearchText= resSectionMiddle.search.invalidSearchText;
		sectionMiddle.download.label = resSectionMiddle.download;
		this.myQuotesTableLabels = resSectionMiddle.gridData;
		sectionMiddle.noResult.noResultFoundText=resSectionMiddle.noResult.noResultFoundText;
		this.state.sectionMiddle.noResult.noQuotesAvailble=resSectionMiddle.noResult.noQuotesAvailble;
		sectionMiddle.noResult.noResultFoundSubText=resSectionMiddle.noResult.noResultFoundSubText;
		this.mapMyQuotesFilterLabels(resSectionMiddle);
	}
	public mapMyQuotesFilterLabels(resSectionMiddle: MyQuotesSectionMiddleLabel): void 
	{
		const sectionMiddleFilter = this.state.sectionMiddle.filteringPanelSection;
		sectionMiddleFilter.filterLabel = resSectionMiddle.filter.filterText;
		sectionMiddleFilter.filterIconAltText = resSectionMiddle.filter.filterIcon.altText;
		sectionMiddleFilter.selectedFilterLabel = resSectionMiddle.filter.selectedFilters;
		sectionMiddleFilter.clearAll = resSectionMiddle.filter.clearAll;
		sectionMiddleFilter.invalidSearchText = resSectionMiddle.invalidSearchText;
		sectionMiddleFilter.filterState.filterData.heading.label = resSectionMiddle.filterForm.formLabel;
		sectionMiddleFilter.filterState.filterData.sections[0].label = resSectionMiddle.filterForm.dateRange.label;
		sectionMiddleFilter.filterState.filterData.sections[1].label = resSectionMiddle.filterForm.billingAddress.label;
		sectionMiddleFilter.filterState.filterData.sections[1].noResultsFoundText =	resSectionMiddle.filterForm.billingAddress.noResultsFoundLabel;
		sectionMiddleFilter.filterState.filterData.sections[1].controls[0].inputPlaceholderText = resSectionMiddle.filterForm.billingAddress.searchPlaceholder;
		sectionMiddleFilter.filterState.filterData.ctaList[0].label = resSectionMiddle.filterForm.clearAllButtonLabel;
		sectionMiddleFilter.filterState.filterData.ctaList[1].label = resSectionMiddle.filterForm.applyButtonLabel;
		this.mapDateRangeValues(resSectionMiddle.filterForm.dateRange.values);
	}
	public mapDateRangeValues(data: string[]): void 
	{
		const dateRange: Option[] = [];
		const dateResponse = data;
		dateResponse.forEach((type) => 
		{
			dateRange.push({ label: type, value: type, checked: false });
		});
		const sectionMiddle = this.state.sectionMiddle;
		const filterData = sectionMiddle.filteringPanelSection.filterState.filterData;
		if (filterData) 
		{
			filterData.sections[0].controls[0].options = dateRange;
			filterData.sections[0].selectedValue = [DateRange.lastSixtyDays];
		}
		const control = filterData.sections[0].controls;
		const index = control[0].options.findIndex(opt => opt.label === DateRange.lastSixtyDays);
		if (index !== 0) 
			control[0].options[index].checked = true;
	}
	initializePayload() 
	{
		this.initializeDatePayload();
		this.myQuotesPayload.status = [ StatusPayload.ordered, StatusPayload.expired, StatusPayload.quoteAccepted, StatusPayload.quoteinProcess, StatusPayload.readyForReview  ];
		this.myQuotesPayload.searchValue = '';
		this.myQuotesPayload.locations = [];
	}
	initializeDatePayload()
	{
		this.myQuotesPayload.endDate = this.dateService.getUnixTimeStamp(this.currentDate);
		this.myQuotesPayload.startDate = this.dateService.getFromDate(new Date(), 60);
	}
	getQuotesTable(page: number): void
	{
		this.myQuotesCardListObject.loading = true;
		if (this.myQuotesTableStateObject)
		{
			this.myQuotesCardListObject = MyQuotesFactory.buildMyQuotetList();
			this.myQuotesCardListObject.list = [];
			this.myQuotesPayload.skip = page;
			if(this.myQuotesPayload.endDate)
			{
				this.myQuotesPayload.endDate = new Date(this.myQuotesPayload.endDate).toISOString().substring(0, 10);
			}
			if(this.myQuotesPayload.startDate)
			{
				this.myQuotesPayload.startDate = new Date(this.myQuotesPayload.startDate).toISOString().substring(0, 10);
			}
			this.getEquipmentQuotesTableData(this.myQuotesPayload);
		}
	}
	getEquipmentQuotesTableData(payload: MyQuotesPayload): void
	{
		this.sharedService
			.getLoggedInUseLocationsIdsObs()
			.pipe(
				tap((locationIds: string[]) =>
				{
					payload.locations = this.myQuotesPayload.locations.length > 0 ? this.myQuotesPayload.locations:locationIds;
				}),
				concatMap(() => this.apiService.getEquipmentQuoteTableData(payload))
			)
			.subscribe({
				next: (res: ApiResponse) =>
				{
					if (res?.data)
					{
						const data = <EquipmentQuoteListResponse>res.data;
						this.mapEquipmentQuotesData(data);
						if(payload.searchValue && payload.searchValue.length >= 4 && data.records)
						{
							this.myQuotesUtilService.trackAnalytics(data.records, this.searchData, this.myQuotesCardListObject.pageInfo?.totalCount);
						}
					}
				},
				error: (error) =>
				{
					this.getHeader();
					this.handleError(error);
				},
				complete: () =>
				{
					setTimeout(() =>
					{
						this.myQuotesCardListObject.loading = false;
						this.myQuotesTableStateObject.next(this.myQuotesCardListObject);
					}, 1000);
				}
			});
	}
	handleError(error: HttpErrorResponse): void
	{
		if(error.error.statusCode === 500)
		{
			const quoteApiError = error.error.message?.split('.');
			this.state.sectionMiddle.noResult.noResultFoundText=quoteApiError[0];
			this.state.sectionMiddle.noResult.noResultFoundSubText=quoteApiError[1];
			this.myQuotesCardListObject.loading = false;
			this.myQuotesCardListObject.error = {
				message: this.state.sectionMiddle.noResult.noResultFoundText,
				messageSubText: this.state.sectionMiddle.noResult.noResultFoundSubText,
				icon: Icons.noResult
			};
			this.myQuotesUtilService.trackErrorByEvent('MyQuote List API Error', error.error.message);
		}
	}
	getHeader()
	{
		this.myQuotesCardListObject.header = [];
		const headerList = Object.values(this.myQuotesTableLabels);
		headerList.slice(0, 6).forEach((val) => 
		{
			const header: KngHeaderObjState = {
				label: val,
				isSort: true,
				sortOrder: SortOrder.desc
			};
			if (header.label === this.sortingEvent.label) 
			{
				header.sortOrder = this.sortingEvent.sortOrder;
			}
			this.myQuotesCardListObject.header.push(header);
		});
	}
	mapEquipmentQuotesData(data: EquipmentQuoteListResponse)
	{
		this.updateCardState = MyQuotesFactory.buildMyQuotetList();
		this.myQuotesCardListObject = MyQuotesFactory.buildTableData();
		this.myQuotesCardListObject.view = window.innerWidth >= 768 ? ScreenView.accordionDeskTop : ScreenView.accordionMobile;
		this.myQuotesCardListObject.cardListOrangeIcon = this.sharedUtilService.getCardListOrangeIcon();
		this.myQuotesCardListObject.cardListGrayIcon = this.sharedUtilService.getCardListGreyIcon();
		this.myQuotesCardListObject.cardListAccordionIcon = this.sharedUtilService.getCardListAccordionIcon();
		this.myQuotesCardListObject.pageInfo = data?.pageInfo;
		this.getHeader();	  
		this.totalCount = data?.pageInfo?.totalCount;
		const isFilterApplied = this.myQuotesUtilService.checkForFilterApplied(this.myQuotesPayload);
		if (data?.records?.length > 0)
		{
			this.getGridData(data);
			this.getMyQuotesStatusCount(data);
			this.checkForActiveIndex();
		}
		else if (data?.records?.length === 0 && isFilterApplied) 
		{
			this.myQuotesCardListObject.error = {
				message: this.state.sectionMiddle.noResult.noResultFoundText,
				messageSubText: this.state.sectionMiddle.noResult.noResultFoundSubText,
				icon: Icons.noResult
			};
			this.getMyQuotesStatusCount(data);
		}
		else 
		{
			this.myQuotesCardListObject.error = {
				message: this.state.sectionMiddle.noResult.noQuotesAvailble,
				messageSubText: this.state.sectionMiddle.noResult.noResultFoundSubText,
				icon: Icons.noResult
			};
			this.getMyQuotesStatusCount(data);
		}
	}
	checkForActiveIndex()
	{
		if (this.sortingEvent.label)
		{
			const headers = this.myQuotesCardListObject.header;
			for (const index in headers)
			{
				if (this.sortingEvent.label === headers[index].label)
					this.myQuotesCardListObject.activeIndex = parseInt(index);
			}
		}
	}
	public getGridData(data: EquipmentQuoteListResponse)
	{
		data.records.forEach((obj) =>
		{
			const quoteDataOrderObj=MyQuotesFactory.myQuoteTabelData();
			obj = Object.assign(quoteDataOrderObj, obj);
			this.deleteObjectProperties(obj);
			const gridObj: KngValueObjState = {
				collapsed: false,
				values: []
			};
			this.getGridDataMap(obj, gridObj);
		});
		this.updateCardState = this.myQuotesCardListObject;
	}
	getGridDataMap(obj: MyQuotesGridListObj, gridObj:KngValueObjState)
	{
		Object.entries(obj).forEach(([ key, value ]) =>
		{
			const label = this.sharedService.getLabel(key, this.myQuotesTableLabels);
			if (label !== '')
			{
				const valueState: KngValueListState = {
					label: label,
					labelValue: value,
					icon: '',
					cssClass: '',
					category: this.myQuotesUtilService.checkCategory(key)
				};
				if (key === FieldName.billingAddress) 
				{
					valueState.labelValue = this.myQuotesUtilService.formatAddress(value);
				}
				if (key === FieldName.dealership) 
				{
					valueState.labelValue = this.myQuotesUtilService.getDealerShipDetail(value);
				}
				if(key === FieldName.status)
				{
					valueState.labelValue = this.myQuotesUtilService.checkStatus(value);
				}
				gridObj.documentURL = obj.documentURL;
				gridObj.values.push(valueState);
			}
		});
		this.myQuotesCardListObject.list.push(gridObj);
	}
	deleteObjectProperties(obj: MyQuotesGridListObj) 
	{
		if (obj.status !== StatusPayload.ordered  && obj.status !== StatusPayload.quoteAccepted) 
			delete obj.orderID;
	}
	getMyQuotesStatusCount(data: EquipmentQuoteListResponse): void
	{
		this.state.sectionMiddle.invoiceStatusUpdated = false;
		if (this.invoiceStatusCount)
		{
			this.invoiceStatusCount.count.forEach((status) => 
			{
				status.amount = data.inProcessCount + data.acceptedCount + data.orderedCount + data.expiredCount + data.readyForReviewCount;
				status.amount = this.myQuotesUtilService.getMyQuotesStatusAmount(status, data);
			});
		}
		setTimeout(() =>
		{
			this.state.sectionMiddle.invoiceStatusUpdated = true;
		});
	}
	downloadMyQuotesData(page: number): void
	{
		this.myQuotesPayload.skip = page;
		const payload = this.myQuotesPayload;
		payload.limit = this.totalCount;
		this.state.sectionMiddle.download.disabled= true;
		this.apiService.downloadMyQuotesTableList(payload).subscribe({ next: (res) =>
		{
			const date = new Date().toString();
			const fileName = FileName.myQuotesList + '_' + this.dateService.tranformDate(date, 'MMddyyyyhhmmss');
			this.sharedService.downloadExcel(fileName, res);
			const download: TrackFileDownload = { fileName, fileType: 'My Quotes' };
			this.myQuotesUtilService.trackSuccessByEvent('Download Success', 'MyQuotes - Download Button', undefined, download);
			this.state.sectionMiddle.download.disabled= false;
		},
		error: (error: HttpErrorResponse): void =>
		{
			if(error)
			{
				this.handleDownloadError(error);
			}
		},
		complete: () =>
		{
			setTimeout(() =>
			{
				this.myQuotesCardListObject.loading = false;
				this.state.sectionMiddle.download.disabled= false;
			}, 1000);
		}
		});
	}
	async handleDownloadError(error: HttpErrorResponse): Promise<HttpErrorResponse>
	{
		const errormessage = JSON.parse(await error.error.text()).message;
		this.loggerService.error( 'error in My Quotes Table Data download', error );
		this.state.sectionMiddle.download.disabled= false;
		this.toaster.error(ErrorMessage.downloadError);
		this.myQuotesUtilService.trackErrorByEvent('Download Failed', errormessage, 'MyQuotes - Download Button');
		throw error;
	}
	getdownloadQuotePdf( documentURL: string | undefined)
	{
		const downloadPdfpayload : DownloadPDFPayload = {
			documentURL: documentURL
		};
		const pdfFileName = (documentURL?.split('=') ?? [])[1];
		this.apiService.downloadQuotePDF(downloadPdfpayload).subscribe({ next: (res) =>
		{
			this.sharedService.downloadPDF(pdfFileName, res);
			const download: TrackFileDownload = { pdfFileName, fileType: 'My Quotes' };
			this.myQuotesUtilService.trackSuccessByEvent('Download Success', 'MyQuotes - Download Button', undefined, download);
		},
		error: (error: HttpErrorResponse): void =>
		{
			if(error)
			{
				this.handlePDFDownloadError(error);
			}
		}
		});
	}
	async handlePDFDownloadError(error: HttpErrorResponse)
	{
		const errormessage = JSON.parse(await error.error.text()).message;
		this.loggerService.error( 'error in My Quotes PDF Download', error );
		this.toaster.error(errormessage);
		this.myQuotesUtilService.trackErrorByEvent('Download Failed', errormessage, 'MyQuotes Download Button');
		throw error;
	}
}
